export function mealHasPersistedContent(meal = {}) {
  return (Array.isArray(meal?.options) ? meal.options : []).some((option) =>
    (Array.isArray(option?.items) ? option.items : []).some(
      (item) => item && typeof item === "object",
    ),
  );
}
